<template>
  <div class="header-container">
    <div
      class="menu01-box"
      v-show="$store.state.isNav"
      @mouseout="moveNav()"
      @mouseover="removeNav()"
    >
      <ul class="main header-menu menu01">
        <li>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/index')"
              to="/index"
              target="_blank"
              >首页</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/exhibition')"
              to="/exhibition"
              target="_blank"
              >数字展厅</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/threeD')"
              to="/threeD"
              target="_blank"
              >3D动画</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/applet')"
              to="/applet"
              target="_blank"
              >小程序开发</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/app')"
              to="/app"
              target="_blank"
              >APP开发</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/mg')"
              to="/mg"
              target="_blank"
              >MG动画</router-link
            >
          </div>
        </li>
        <!-- <li> -->
        <!-- <div :class="['header-menu-item','line']">
            <router-link :class="['menu-item-link','menuOneRow']" to='/ar' @click.native="toNav()">AR</router-link>
          </div> -->
        <!-- <div :class="['header-menu-item','line']">
            <router-link :class="['menu-item-link','menuOneRow']" to='/vr' @click.native="toNav()">VR</router-link>
          </div> -->
        <!-- <div :class="['header-menu-item','line']">
            <router-link :class="['menu-item-link','menuOneRow']" to='/vrselect' @click.native="toNav()">线上选型</router-link>
          </div> -->
        <!-- </li> -->

        <li>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/overseas')"
              to="/overseas"
              target="_blank"
              >海外推广</router-link
            >
          </div>
          <div :class="['header-menu-item', 'line']">
            <router-link
              :class="['menu-item-link', 'menuOneRow']"
              @click.native="toNav('/video')"
              to="/video"
              target="_blank"
              >短视频运营</router-link
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //移入显示导航栏
    moveNav() {
      this.$store.commit("SET_ISNAV", false);
    },
    removeNav() {
      this.$store.commit("SET_ISNAV", true);
    },
    toNav(path) {
      /*
      var routeUrl = this.$router.resolve({
        path: path,
      });
      window.open(routeUrl.href, "_blank");
      */
    },
  },
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
